/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttendanceMarkRequest } from './AttendanceMarkRequest';
import {
    AttendanceMarkRequestFromJSON,
    AttendanceMarkRequestFromJSONTyped,
    AttendanceMarkRequestToJSON,
    AttendanceMarkRequestToJSONTyped,
} from './AttendanceMarkRequest';

/**
 * 
 * @export
 * @interface BulkAttendanceRequest
 */
export interface BulkAttendanceRequest {
    /**
     * 
     * @type {Array<AttendanceMarkRequest>}
     * @memberof BulkAttendanceRequest
     */
    attendances: Array<AttendanceMarkRequest>;
}

/**
 * Check if a given object implements the BulkAttendanceRequest interface.
 */
export function instanceOfBulkAttendanceRequest(value: object): value is BulkAttendanceRequest {
    if (!('attendances' in value) || value['attendances'] === undefined) return false;
    return true;
}

export function BulkAttendanceRequestFromJSON(json: any): BulkAttendanceRequest {
    return BulkAttendanceRequestFromJSONTyped(json, false);
}

export function BulkAttendanceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkAttendanceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'attendances': ((json['attendances'] as Array<any>).map(AttendanceMarkRequestFromJSON)),
    };
}

export function BulkAttendanceRequestToJSON(json: any): BulkAttendanceRequest {
    return BulkAttendanceRequestToJSONTyped(json, false);
}

export function BulkAttendanceRequestToJSONTyped(value?: BulkAttendanceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attendances': ((value['attendances'] as Array<any>).map(AttendanceMarkRequestToJSON)),
    };
}

